// extracted by mini-css-extract-plugin
module.exports = {"comment":"EventsDataSection-comment-2PHAnl"};